import styled from "styled-components";
import {colors} from "../../common/colors";

type Props = {
  type?:'text'|'password'|'number'|'submit'|'email';
  className?: string;
  value: string|number;
  placeholder?: string;
  onChange: (e:React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (e:React.KeyboardEvent<HTMLInputElement>) => void;
  checked?: boolean;
  disabled?: boolean;
  max?: number;
  min?: number;
}

export default function Input(props:Props) {
  return (
    <Container
      type={props.type}
      className={props.className}
      value={props.value}
      placeholder={props.placeholder}
      onChange={props.onChange}
      onKeyDown={props.onKeyDown}
      checked={props.checked}
      disabled={props.disabled}
      max={props.max}
      min={props.min}
      />
  )
}

const Container = styled.input`
  position: relative;
  border: none;
  padding: 0;
  margin: 0;
  
  &::placeholder {
    color: ${colors.lightGrey};
  }
  
  &.default { // use: sign
    font-size: 20px;
    color: ${colors.black};
    border-radius: 12px;
    border: 1px solid ${colors.lightGrey};
    &:focus {
      border: 1px solid ${colors.button.blue};
    }
  }
`